import buildImageUrl from '../../../../lib/media-url-maker'

const transformThumbnail = ({ image, ratio }) => {
  const width = 300
  return buildImageUrl({
    resource: image,
    width,
    height: Math.round(width * ratio),
    mode: 'cover',
    quality: 60
  })
}

const transformExteriorImages = ({ images, ratio }) => {
  const width = 1000
  const widths = [560, 800, 1000, 1600]
  return images.map((fileName, i) => ({
    src: buildImageUrl({
      resource: fileName,
      width,
      height: Math.round(width * ratio),
      mode: 'cover',
      quality: 80
    }),
    srcSet: Object.assign(
      {},
      ...widths.map((width) => ({
        [width]: buildImageUrl({
          resource: fileName,
          width,
          height: Math.round(width * ratio),
          mode: 'cover',
          quality: i === 0 ? 80 : 60
        })
      }))
    )
  }))
}

const transformPanorama = ({ image }) => {
  return buildImageUrl({
    resource: image,
    width: 6000
  })
}

const transformPanoramaPoster = ({ image, ratio }) => {
  const width = 400
  return buildImageUrl({
    resource: image,
    width,
    height: Math.round(width * ratio),
    mode: 'cover',
    quality: 60
  })
}

const transformPhoto = ({ image, ratio }) => {
  // Large widths are to account for the zoom-in functionality needing additional detail
  const widths = [560, 800, 1000, 1600, 2000, 3000, 4000]
  return {
    src: buildImageUrl({
      resource: image,
      width: 1600,
      height: 760,
      mode: 'cover'
    }),
    minimap: buildImageUrl({
      resource: image,
      width: 320,
      height: 180,
      mode: 'cover'
    }),
    srcSet: Object.assign(
      {},
      ...widths.map((width) => ({
        [width]: buildImageUrl({
          resource: image,
          width,
          height: Math.round(width * ratio),
          mode: 'cover'
        })
      }))
    )
  }
}

export {
  transformThumbnail,
  transformExteriorImages,
  transformPanorama,
  transformPanoramaPoster,
  transformPhoto
}
